import { RootState } from "../../../store";
import { type State } from "./activeLearningPath.state";

export const getActiveLearningPath = (state: RootState): State =>
  state.activeLearningPath;
